import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Schedule } from 'models/ScheduleModel';
import { ScheduleColumn } from 'models/BaseModel';

const ScheduleMultiForm: React.FC = () => {
  const width = { date: 40, start: 30, end: 30}
  const [formId, formName] = [Code.Form.Id.SCHEDULE, Code.Form.Name.SCHEDULE];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [searchParams] = useSearchParams();
  const branchId = searchParams.get(Code.UrlPara.Branch);
  const startDate = searchParams.get(Code.UrlPara.StartDate);
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [branchOptions, setBranchOptions] = Hooks.Form.Options();
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [monthDayOptions, setMonthDayOptions] = Hooks.Form.Options();
  const [scheduleColumnData, setScheduleColumnData] = useState<ScheduleColumn[]>([]);
  const [formData, setFormData] = useState<Schedule>({});

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.OPTION+Code.Group.SCHEDULE_TYPE, Code.Option.Common.NA, setTypeOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.SCHEDULE_STATUS, Code.Option.Common.NA, setStatusOptions, setError);
    Files.Json.API(Code.File.LOCATION, Code.Option.Common.SELECT, setBranchOptions, setError);
    Files.Json.API(Code.File.DOCTOR, Code.Option.Common.SELECT, setDoctorOptions, setError);
    setMonthDayOptions( Utility.Get.MonthDays(2026, 1));
 
    API.Data.GetByKeyId<Schedule>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.schedule_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
      }})
      setLoading(false);
  }, []);

  

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
    });

    finalData.schedule_start_date = finalData.schedule_start_date || Utility.Date.Current();
    finalData.schedule_end_date = finalData.schedule_start_date || Utility.Date.Current();
    finalData.schedule_start_time = Utility.Convert.TimeOrNow(finalData.schedule_start_time);
    finalData.schedule_end_time = Utility.Convert.TimeOrNow(finalData.schedule_end_time);
    if(keyId==Code.Key.NEW) {
        if(branchId) finalData.branch_id = branchId;
        if(startDate) {
          finalData.schedule_start_date = startDate;
          finalData.schedule_end_date = startDate;
        }
    }
    
    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  const handleFieldChange = (
    row: number,
    field: keyof ScheduleColumn,
    newValue: string | null
  ) => {
    // setScheduleColumnData((prev) => {
    //   const rowNum = row;
    //   const existingIndex = prev.findIndex((item) => item.row === rowNum);

    //   if(field === Name.Schedule.StartDate){
    //     const selected = hscOptions.find(option => option.value === Number(newValue));
    //     if(selected){
    //       const dob = formData?.client_dob;
    //       const isChild = dob && Utility.isValid.ChildAge(dob);
    //       priceAmount = isChild ? Number(selected.data3) : Number(selected.data2);
    //     }
        
    //   }
    
    //   if (field === Name.Billing.Hsc && (!newValue || newValue.trim() === "")) {
    //     return prev.filter((item) => item.row !== rowNum);
    //   } 
    //   else {
    //     if (existingIndex !== -1) {
    //       return prev.map((item, idx) =>
    //         idx === existingIndex 
    //           ? { 
    //               ...item, 
    //               [field]: newValue,
    //               ...(field === Name.Billing.Hsc && { billing_price: priceAmount, billing_quantity: 1, billing_amount: priceAmount })
    //             } 
    //           : item
    //       );
    //     } else {
    //       return [
    //         ...prev, 
    //         { 
    //           row: rowNum, 
    //           [field]: newValue,
    //           ...(field === Name.Billing.Hsc && { billing_price: priceAmount, billing_quantity: 1, billing_amount: priceAmount })
    //         }
    //       ];
    //     }
    //   }
    // });
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} clientNumber={formData.client_number} formName={formName} Privilege={Privilege} />
          <Control.Tab.Header titles={["Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Select id={Name.Common.BranchId} value={formData.branch_id} title={Title.Location} options={branchOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} selected={branchId} />
                <Field.Date id={Name.Schedule.StartDate} value={formData.schedule_start_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]}  require={true} currentDate={true} selected={startDate}  />
              </Control.Row>
              <Control.Row>
                <Field.Time id={Name.Schedule.StartTime} value={formData.schedule_start_time} title={Title.StartTime} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true}  />
                <Field.Time id={Name.Schedule.EndTime} value={formData.schedule_end_time} title={Title.EndTime} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} />
              </Control.Row>
              <Control.Box>
                <Field.Select id={Name.Doctor.Id} value={formData.doctor_id} title={Title.Doctor} options={doctorOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true}  />
                <Field.Area id={Name.Schedule.Comment} value={formData.schedule_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Box>
              <Control.Row>
                <Field.Select id={Name.Common.TypeId} value={formData.type_id} title={Title.Type} options={typeOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,0]} />
                <Field.Select id={Name.Common.StatusId} value={formData.status_id} title={Title.Status} options={statusOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
            </Control.Tab.Content>

            <Control.Form.Table>
              <Control.Form.Title>
                <Control.Grid.Items values={[
                  ["Date", width.date],
                  ["Start", width.start], 
                  ["End", width.end ]
                ]} />
              </Control.Form.Title>
              <Control.Form.List>
                {monthDayOptions.map((item, index) => {
                  const current = scheduleColumnData?.find((d) => d.row === item.value) || {};
                  return(
                  <Control.Form.Index key={item.value} index={index}>
                    <Control.Form.Item>
                      <Control.Form.Date id={Name.Billing.Hsc} value={current.schedule_start_date} onChange={(e) => handleFieldChange(item.value, "schedule_start_date", e.target.value)} size={[width.date]} />
                      {/* <Control.Form.Option id={Name.Billing.Diagnosis1} value={current.billing_diagnosis1_id} optionValues={diagOptions} onChange={(e) => handleFieldChange(item.value, "billing_diagnosis1_id", e.target.value)} size={[width.diagnosis]} />
                      <Control.Form.Number id={Name.Billing.Price} value={current.billing_price} onChange={(e) => handleFieldChange(item.value, "billing_price", e.target.value)}  size={[width.price]} />
                      <Control.Form.Number id={Name.Billing.Quantity} value={current.billing_quantity} onChange={(e) => handleFieldChange(item.value, "billing_quantity", e.target.value)}  size={[width.quantity]} />
                      <Control.Form.Number id={Name.Billing.Amount} value={current.billing_amount} onChange={(e) => handleFieldChange(item.value, "billing_amount", e.target.value)}  size={[width.amount]} /> */}
                    </Control.Form.Item>
                  </Control.Form.Index>
                  );
                })}
              </Control.Form.List>
            </Control.Form.Table>
 
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default ScheduleMultiForm;